<template>
  <v-dialog
    scrollable
    width="538px"
    :value="show"
    @click:outside="$emit('close')"
  >
    <v-card class="px-8">
      <v-card-title class="px-0 h6">{{ checklist.name }}</v-card-title>

      <v-card-text class="px-0 ma-0">
        <ChecklistOverview hideTitle :checklist="checklist" />
      </v-card-text>
      <v-card-actions class="ma-0 px-0 py-4 justify-end">
        <Button
          plain
          color="grey"
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
import ChecklistOverview from '@/components/Checklists/ChecklistOverview.vue'
export default {
  props: {
    show: Boolean,
    checklist: { type: Object, required: true },
  },
  components: {
    Button,
    ChecklistOverview,
  },
}
</script>
